<div class="bredcrumbWrp">
  <!-- <ul>
        <li>
            Profile
        </li>
        <li>Profile</li>
    </ul> -->
</div>
<div class="pageWrapper">
  <div class="flex top_heading">
    <h2 class="pageTitle">My Profile</h2>
    <button id="module_profile_module_profile_1" mat-button class="profile_btn" (click)="openDialog()">
      <span class="icon">
        <lucide-icon name="SquarePen" class="icon"></lucide-icon>
      </span>
      Edit Profile
    </button>
  </div>

  <div class="row">
    <div class="profileWrapp">
      <div class="profileInfo">
        <div class="userInfo">
          <div class="cmn_box">
            <div class="userProfile">{{ getName() }}</div>
            <h3>{{ name.title }} {{ name.firstName | titlecase }} {{ name.lastName | titlecase }}</h3>
            <span class="userStatus">Customer ID: #{{ leftPanelInfo?.response?.tempId }}</span>
          </div>

          <div class="cmn_box">
            <ul>
              <li>
                <span class="profle_label"> <lucide-icon name="Briefcase" class="icon"></lucide-icon> Company </span>
                <span class="name"> {{ profileInfo?.response?.customerCompanyProfile.name }} </span>
              </li>
              <li>
                <span class="profle_label"> <lucide-icon name="Building2" class="icon"></lucide-icon> Department </span>
                <span class="name"> {{ leftPanelInfo?.response?.functionalDepartmentName }} </span>
              </li>
            </ul>
          </div>
        </div>

        <div class="userDetails">
          <div class="cmn_box">
            <ul>
              <li>
                <span class="profle_label">
                  <lucide-icon name="Mail" class="icon"></lucide-icon>
                  <span class="text_ellipse" matTooltip="{{ leftPanelInfo?.response?.email }}"> {{ leftPanelInfo?.response?.email }} </span>
                </span>

                <!-- <span class="cntStatus">
                <mat-icon class="success">check_circle_outline</mat-icon>
              </span> -->
              </li>
              <li>
                <span class="profle_label">
                  <lucide-icon name="Phone" class="icon"></lucide-icon>
                  {{ leftPanelInfo?.response?.phoneNo }}
                </span>
              </li>
            </ul>
          </div>

          <div class="progressInfo">
            <legend class="flex alignCenter">
              Profile Completion
              <span class="progessCount ml-auto"> {{ leftPanelInfo?.response?.finalProfileScoreInPercent }}% </span>
            </legend>
            <mat-progress-bar mode="determinate" [value]="leftPanelInfo?.response?.finalProfileScoreInPercent"></mat-progress-bar>
          </div>
        </div>
      </div>

      <div class="kam-info" *ngIf="leftPanelInfo?.response?.ownerEmail && leftPanelInfo?.response?.ownerName">
        <h3 class="kam-info-heading">Region Incharge</h3>
        <div class="cmn_box">
          <ul>
            <li>
              <span class="profle_label">
                <lucide-icon name="User" class="icon"></lucide-icon>
                {{ leftPanelInfo?.response?.ownerName }}
              </span>
            </li>
            <li>
              <span class="profle_label">
                <lucide-icon name="Mail" class="icon"></lucide-icon>
                <span class="text_ellipse" matTooltip="{{ leftPanelInfo?.response?.ownerEmail }}">
                  {{ leftPanelInfo?.response?.ownerEmail }}
                </span>
              </span>
            </li>
          </ul>
        </div>
      </div>
      <div class="kam-info" *ngIf="leftPanelInfo?.response?.kamDetails?.length">
        <h3 class="kam-info-heading">Key Account Manager</h3>
        <div class="cmn_box">
          <ul>
            <li *ngFor="let kamDetail of leftPanelInfo?.response?.kamDetails; let i = index">
              <div class="profle_label">
                <lucide-icon name="Mail" class="icon"></lucide-icon>
                <span class="mailWrapp">
                  <span class="text_ellipse" matTooltip="{{ kamDetail?.kamEmailID }}"> {{ kamDetail?.kamEmailID }} </span>
                </span>
              </div>
              <div class="profle_label">
                <lucide-icon name="Phone" class="icon"></lucide-icon>
                <span class="mailWrapp">
                  {{ kamDetail?.kamName }}
                </span>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="companyDetails">
      <mat-tab-group class="customTabs profile_detail" #profileTabs dynamicHeight animationDuration="10ms">
        <mat-tab label="Company" *ngIf="companyTab">
          <div class="tabInner">
            <div class="detailsItem">
              <h4 class="itemTitle flex alignCenter font-16" [ngClass]="activeIndex == 1 ? 'active' : ''" (click)="toggleAccordion(1)">
                <lucide-icon name="Building" class="user_icon"></lucide-icon>
                Company Details

                <span class="accordianButton" [ngClass]="activeIndex == 1 ? 'active' : ''">
                  <lucide-icon name="chevron-down" [size]="16" class="lucid-icon-arrow"></lucide-icon>
                </span>
              </h4>

              <div class="row" *ngIf="activeIndex == 1">
                <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                  <div class="dtlSingle">
                    <label class="font-14">Company Address</label>
                    <legend class="medium font-16">{{ profileInfo?.response?.customerCompanyProfile?.address }}</legend>
                  </div>
                </div>
                <div class="col-lg-12 col-md-12 col-sm-12 col-12">
                  <div class="dtlSingle">
                    <label class="font-14">Company Contact</label>
                    <legend class="medium font-16">{{ profileInfo?.response?.customerCompanyProfile?.contactNumber }}</legend>
                  </div>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                  <div class="dtlSingle">
                    <label class="font-14">ZipCode</label>
                    <legend class="medium font-16">{{ profileInfo?.response?.customerCompanyProfile?.pincode }}</legend>
                  </div>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                  <div class="dtlSingle">
                    <label class="font-12 font-14">City</label>
                    <legend class="medium font-16">{{ profileInfo?.response?.customerCompanyProfile?.cityName }}</legend>
                  </div>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                  <div class="dtlSingle">
                    <label class="font-14">State</label>
                    <legend class="medium font-16">{{ profileInfo?.response?.customerCompanyProfile?.stateName }}</legend>
                  </div>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                  <div class="dtlSingle">
                    <label class="font-14">Country</label>
                    <legend class="medium font-16">{{ profileInfo?.response?.customerCompanyProfile?.countryName }}</legend>
                  </div>
                </div>

                <div class="col-sm-12 separator"></div>

                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                  <div class="dtlSingle">
                    <label class="font-14">Company Website</label>
                    <legend class="medium font-16">{{ profileInfo?.response?.customerCompanyProfile?.websiteUrl }}</legend>
                  </div>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                  <div class="dtlSingle">
                    <label class="font-14">Establishment Year</label>
                    <legend class="medium font-16">{{ profileInfo?.response?.customerCompanyProfile?.establishmentYear }}</legend>
                  </div>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                  <div class="dtlSingle">
                    <label class="font-14"
                      >Listing
                      <span
                        class="label_icon"
                        matTooltip="This indicates whether the company is publicly listed on a stock exchange (Public) or privately held (Private)."
                        ><lucide-icon name="CircleHelp" class="icon"></lucide-icon
                      ></span>
                    </label>
                    <legend
                      class="medium font-16"
                      *ngIf="profileInfo?.response?.customerCompanyProfile?.publicated == true; else notListed"
                    >
                      Yes
                    </legend>
                    <ng-template #notListed><legend>No</legend></ng-template>
                  </div>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                  <div class="dtlSingle">
                    <label class="font-14"
                      >Development Type
                      <span class="label_icon" matTooltip="Whether the organization is newly established or long-standing."
                        ><lucide-icon name="CircleHelp" class="icon"></lucide-icon></span
                    ></label>
                    <legend
                      class="medium font-16"
                      *ngIf="profileInfo?.response?.customerCompanyProfile?.developmentNew == true; else notListedd"
                    >
                      New
                    </legend>
                    <ng-template #notListedd><legend>Existing</legend></ng-template>
                  </div>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                  <div class="dtlSingle">
                    <label class="font-14">Expected Timelines</label>
                    <legend class="medium font-16">
                      {{
                        profileInfo?.response?.customerCompanyProfile?.timelineOther ||
                          profileInfo?.response?.customerCompanyProfile?.timelineName
                      }}
                    </legend>
                  </div>
                </div>

                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                  <div class="dtlSingle">
                    <label class="font-14"
                      >Turnover
                      <span class="label_icon" matTooltip="Annual revenue in million USD for the latest financial year."
                        ><lucide-icon name="CircleHelp" class="icon"></lucide-icon></span
                    ></label>
                    <legend class="medium font-16">{{ profileInfo?.response?.customerCompanyProfile?.turnover }}</legend>
                  </div>
                </div>

                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                  <div class="dtlSingle">
                    <label class="font-14">Total Employee</label>
                    <legend class="medium font-16">{{ profileInfo?.response?.customerCompanyProfile?.companySize }}</legend>
                  </div>
                </div>

                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                  <div class="dtlSingle">
                    <label class="font-14">Company Profile</label>
                    <div *ngIf="profileInfo?.response?.customerCompanyProfile?.brochureDoc?.fileName">
                      <div class="file-upload-status flex alignCenter">
                        <div class="flex alignCenter">
                          <span class="icon"><lucide-icon name="FileText" class="icon"></lucide-icon></span>
                          <span
                            class="file-name"
                            matTooltip="{{ profileInfo?.response?.customerCompanyProfile?.brochureDoc?.fileName }}"
                            matTooltipPosition="left"
                          >
                            {{ profileInfo?.response?.customerCompanyProfile?.brochureDoc?.fileName }}</span
                          >
                        </div>
                        <div class="col-lg-6 col-md-12 col-sm-12 file-upload-size-info flex alignCenter">
                          <!-- <span class="file-size"> {{ profileInfo?.response?.customerCompanyProfile?.brochureDoc?.size }}</span> -->
                          <span
                            (click)="
                              downloadBrochureFile(
                                profileInfo?.response?.customerCompanyProfile?.brochureDoc?.id,
                                profileInfo?.response?.customerCompanyProfile?.brochureDoc?.fileName
                              )
                            "
                          >
                            <lucide-icon name="Download" class="icon"></lucide-icon>
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="col-sm-12 separator"></div>

                <div class="col-md- col-12">
                  <div class="formGroup dtlSingle">
                    <label class="medium font-14">Industry</label>
                    <div class="popupDropdown">
                      <div class="chipIcon">
                        <ng-container *ngFor="let industryChip of industryData">
                          <mat-chip *ngIf="industryChip.sectors.length > 0">
                            {{ industryChip.industryName }} ({{ industryChip.sectors?.length }})
                          </mat-chip>
                        </ng-container>
                      </div>
                      <div class="dialogEdit" *ngIf="industryData.length > 0" (click)="openIndustryDialog()">
                        <lucide-icon name="Plus" class="icon"></lucide-icon>
                      </div>
                      <div *ngIf="!industryData.length || industryData.length < 1">
                        <span class="dialogEdit">
                          <lucide-icon (click)="openIndustryDialog()" name="Plus" class="icon"></lucide-icon>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-md-12 col-12">
                  <div class="formGroup dtlSingle">
                    <label class="medium">Your Interest Area</label>
                    <div class="popupDropdown">
                      <div class="chipIcon">
                        <ng-container *ngFor="let interestChip of interestData">
                          <mat-chip *ngIf="interestChip.interestValues?.length > 0">
                            {{ interestChip.name }} ({{ interestChip.interestValues?.length }})
                          </mat-chip>
                        </ng-container>
                      </div>
                      <div class="dialogEdit" *ngIf="interestData.length > 0" (click)="openInterestDialog()">
                        <lucide-icon name="Plus" class="icon"></lucide-icon>
                      </div>
                      <div *ngIf="!interestData.length || interestData.length < 1">
                        <span class="dialogEdit">
                          <lucide-icon (click)="openInterestDialog()" name="Plus" class="icon"></lucide-icon>
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="detailsItem">
              <h4 class="itemTitle flex alignCenter font-16" [ngClass]="activeIndex == 2 ? 'active' : ''" (click)="toggleAccordion(2)">
                <lucide-icon name="Building2" class="user_icon"></lucide-icon>
                Company Headquaters
                <span class="accordianButton" [ngClass]="activeIndex == 2 ? 'active' : ''">
                  <lucide-icon name="chevron-down" [size]="16" class="lucid-icon-arrow"></lucide-icon>
                </span>
              </h4>

              <div class="row" *ngIf="activeIndex == 2">
                <div class="col-lg-12 col-md-12 col-sm-12">
                  <div class="dtlSingle">
                    <label class="font-14">Company Address</label>
                    <legend class="medium font-16">{{ profileInfo?.response?.customerCompanyProfile?.headquaterAddress }}</legend>
                  </div>
                </div>

                <div class="col-lg-3 col-md-4 col-sm-6">
                  <div class="dtlSingle">
                    <label class="font-14">ZipCode</label>
                    <legend class="medium font-16">{{ profileInfo?.response?.customerCompanyProfile?.headquaterPincode }}</legend>
                  </div>
                </div>

                <div class="col-lg-3 col-md-4 col-sm-6">
                  <div class="dtlSingle">
                    <label class="font-14">City</label>
                    <legend class="medium font-16">{{ profileInfo?.response?.customerCompanyProfile?.headquaterCityName }}</legend>
                  </div>
                </div>

                <div class="col-lg-3 col-md-4 col-sm-6">
                  <div class="dtlSingle">
                    <label class="font-14">State</label>
                    <legend class="medium font-16">{{ profileInfo?.response?.customerCompanyProfile?.headquaterStateName }}</legend>
                  </div>
                </div>

                <div class="col-lg-3 col-md-4 col-sm-6">
                  <div class="dtlSingle">
                    <label class="font-14">Country</label>
                    <legend class="medium font-16">{{ profileInfo?.response?.customerCompanyProfile?.headquaterCountryName }}</legend>
                  </div>
                </div>
              </div>
            </div>

            <div class="detailsItem">
              <h4 class="itemTitle flex alignCenter font-16" [ngClass]="activeIndex == 3 ? 'active' : ''" (click)="toggleAccordion(3)">
                <lucide-icon name="MapPinned" class="user_icon"></lucide-icon>
                Manufacturing Locations
                <span class="accordianButton" [ngClass]="activeIndex == 3 ? 'active' : ''">
                  <lucide-icon name="chevron-down" [size]="16" class="lucid-icon-arrow"></lucide-icon>
                </span>
              </h4>
              <div class="container" *ngIf="activeIndex == 3">
                <!-- <mat-accordion>
                  <div class="accordian-panel" *ngFor="let region of regions; let regionIndex = index">
                    <mat-expansion-panel [expanded]="0">
                      <mat-expansion-panel-header class="expansion-panel-header">
                        <div class="row alignCenter">
                          <div class="col-lg-3 col-md-4 col-sm-12">
                            <div class="expansion-panel-title">
                              <div class="">
                                <legend class="medium">{{ getRegionName(region.regionWisePresenceId) }}</legend>
                              </div>
                            </div>
                          </div>
                        </div>
                      </mat-expansion-panel-header>
                      <div class="expansion-panel-body">
                        <div class="container country-container" *ngFor="let country of region.countries">
                          <div class="row">
                            <div class="col-lg-3 col-md-4 col-sm-6">
                              <div class="dtlSingle">
                                <label class="font-12">Country</label>
                                <legend class="medium">{{ getRegionCountry(region.regionWisePresenceId, country.countryId) }}</legend>
                              </div>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6">
                              <div class="dtlSingle">
                                <label class="font-12">Employees</label>
                                <legend class="medium">{{ manPowerMap.get(country.companySizeId) }}</legend>
                              </div>
                            </div>
                            <div class="col-lg-3 col-md-4 col-sm-6">
                              <div class="dtlSingle">
                                <label class="font-12">Revenue (in USD Million)</label>
                                <legend class="medium">{{ revenueMap.get(country.turnoverId) }}</legend>
                              </div>
                            </div>
                          </div>
                          <div class="row">
                            <div class="col-lg-12 col-md-12 col-sm-12">
                              <div class="dtlSingle">
                                <label class="font-12">Categories</label>
                                <mat-chip-listbox aria-label="Fish selection">
                                  <mat-chip *ngFor="let category of getCategoryName(country.categories)">
                                    {{ category }}
                                  </mat-chip>
                                </mat-chip-listbox>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </mat-expansion-panel>
                  </div>
                </mat-accordion> -->

                <div class="tableDocuments" *ngFor="let region of regions; let regionIndex = index">
                  <div class="heading">
                    <h3>{{ getRegionName(region.regionWisePresenceId) }}</h3>
                  </div>

                  <table>
                    <thead>
                      <tr>
                        <th>Country</th>
                        <th>Employees</th>
                        <th>Revenue (million)</th>
                        <th>Categories</th>
                      </tr>
                    </thead>

                    <tbody>
                      <tr *ngFor="let country of region.countries">
                        <td class="col-lg-3 col-md-4 col-sm-6">
                          {{ getRegionCountry(region.regionWisePresenceId, country.countryId) }}
                        </td>

                        <td class="col-lg-3 col-md-4 col-sm-6">
                          {{ manPowerMap.get(country.companySizeId) }}
                        </td>

                        <td class="col-lg-3 col-md-4 col-sm-6">
                          {{ revenueMap.get(country.turnoverId) }}
                        </td>

                        <td class="col-lg-12 col-md-12 col-sm-12">
                          <div class="chipIcon">
                            <mat-chip-listbox aria-label="Fish selection">
                              <mat-chip *ngFor="let category of getCategoryName(country.categories)">
                                {{ category }}
                              </mat-chip>
                            </mat-chip-listbox>
                          </div>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </mat-tab>

        <mat-tab label="Finance" *ngIf="financeTab">
          <div class="tabInner">
            <div class="detailsItem">
              <h4 class="itemTitle flex alignCenter font-14">
                <lucide-icon name="Landmark" class="user_icon"></lucide-icon>
                Bank Details
              </h4>
              <div class="row">
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <div class="dtlSingle">
                    <label class="font-12">Global VAT</label>
                    <legend class="medium">{{ profileInfo?.response?.finance?.globalVat }}</legend>
                  </div>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <div class="dtlSingle">
                    <label class="font-12">Currency</label>
                    <legend class="medium">{{ profileInfo?.response?.finance?.currency }}</legend>
                  </div>
                </div>

                <div class="col-lg-3 col-md-4 col-sm-6">
                  <div class="dtlSingle">
                    <label class="font-12">Bank Name</label>
                    <legend class="medium">{{ profileInfo?.response?.finance?.bankName }}</legend>
                  </div>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <div class="dtlSingle">
                    <label class="font-12">Account Number</label>
                    <legend class="medium">{{ profileInfo?.response?.finance?.accountNumber }}</legend>
                  </div>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <div class="dtlSingle">
                    <label class="font-12">Bank Code</label>
                    <legend class="medium">{{ profileInfo?.response?.finance?.bankCode }}</legend>
                  </div>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <div class="dtlSingle">
                    <label class="font-12">PAN</label>
                    <legend class="medium">{{ profileInfo?.response?.finance?.pan }}</legend>
                  </div>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6">
                  <div class="dtlSingle">
                    <label class="font-12">Cancellation Cheque</label>
                    <legend class="medium">{{ profileInfo?.response?.finance?.cancelledCheque }}</legend>
                  </div>
                </div>
              </div>
            </div>
            <h4 class="itemTitle flex alignCenter font-12">
              <lucide-icon name="UserCheck" class="user_icon"></lucide-icon>
              KYC Details
            </h4>
            <div class="row">
              <div class="col-lg-3 col-md-4 col-sm-6">
                <div class="dtlSingle">
                  <label class="font-12">Global VAT</label>
                  <legend class="medium">{{ profileInfo?.response?.customerCompanyProfile?.globalVat }}</legend>
                </div>
              </div>
              <div class="col-lg-3 col-md-4 col-sm-6">
                <div class="dtlSingle">
                  <label class="font-12">PAN</label>
                  <legend class="medium">{{ profileInfo?.response?.customerCompanyProfile?.panNumber }}</legend>
                </div>
              </div>
            </div>
          </div>
        </mat-tab>

        <mat-tab label="Terms & Conditions" *ngIf="tncTab">
          <div class="tabInner">
            <div class="detailsItem">
              <div class="row">
                <div class="col-lg-4 col-md-4 col-sm-6">
                  <div class="termsWrapp">
                    <div class="termInner">
                      <div class="termIco">
                        <lucide-icon name="FileText" class="file_icon"></lucide-icon>
                      </div>
                      <div class="termDtl">
                        <h3>Legal Terms & Conditions</h3>
                        <span class="termStatus font-12 success" ngClass="APPROVED" *ngIf="isActiveLegalTermsCondition"> Accepted </span>
                        <span class="termStatus font-12 pending" ngClass="PENDING" *ngIf="!isActiveLegalTermsCondition"> Pending </span>
                      </div>
                    </div>
                    <div class="termLink" (click)="getLegalTermsAndConditions()">
                      <lucide-icon name="MoveUpRight" class="upright_icon"></lucide-icon>
                    </div>
                  </div>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-6">
                  <div class="termsWrapp">
                    <div class="termInner">
                      <div class="termIco">
                        <lucide-icon name="FileText" class="file_icon"></lucide-icon>
                      </div>
                      <div class="termDtl">
                        <h3>Non Disclosure Agreement</h3>
                        <span class="termStatus font-12" [ngClass]="profileInfo?.response?.termsAndConditions?.ndaStatus">
                          {{ getNDALabel(profileInfo?.response?.termsAndConditions?.ndaStatus) }}
                        </span>
                      </div>
                    </div>
                    <div class="termLink" (click)="openNdaDisclosuer(profileInfo?.response?.termsAndConditions?.ndaStatus, $event)">
                      <lucide-icon name="MoveUpRight" class="upright_icon"></lucide-icon>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </mat-tab>

        <mat-tab label="KYC" *ngIf="kycTab">
          <div class="kycStatus" [ngClass]="kycData?.status">
            <lucide-icon name="{{statusKycIcon}}" [size]="18" class="lucid-icon-kyc"></lucide-icon>
            <div class="statusText">
              <h3>{{ statusKycHeading }}</h3>
              <p>{{ statusKycText }}</p>
            </div>
          </div>
          <div class="tabInner">
            <div class="detailsItem">
              <h4 class="itemTitle flex alignCenter font-16" [ngClass]="activeIndex == 1 ? 'active' : ''" (click)="toggleAccordion(1)">
                <lucide-icon name="UserCheck" class="user_icon"></lucide-icon>
                KYC Details
                <span class="accordianButton" [ngClass]="activeIndex == 1 ? 'active' : ''">
                  <lucide-icon name="chevron-down" [size]="16" class="lucid-icon-arrow"></lucide-icon>
                </span>
              </h4>
              <div class="accordion-content" *ngIf="activeIndex == 1">
                <div class="row pr-1">
                  <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div class="dtlSingle">
                      <label class="font-14">Company Name</label>
                      <legend class="medium font-14">{{ kycData?.companyName ?? "NA" }}</legend>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div class="dtlSingle">
                      <label class="font-14">Full legal name of the Company/Entity</label>
                      <legend class="medium font-16">{{ kycData?.legalName ?? "NA" }}</legend>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div class="dtlSingle">
                      <label class="font-14">CIN Type</label>
                      <legend class="medium font-16">{{ kycData?.cinType ?? "NA" }}</legend>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div class="dtlSingle">
                      <label class="font-14">CIN Number</label>
                      <legend class="medium font-16">{{ kycData?.cinNumber ?? "NA" }}</legend>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div class="dtlSingle">
                      <label class="font-14">CIN Country</label>
                      <legend class="medium font-16">{{ kycData?.cinCountryName ?? "NA" }}</legend>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div class="dtlSingle">
                      <label class="font-14">Category Of Business</label>
                      <legend class="medium font-16">{{ kycData?.categoryOfBusiness ?? "NA" }}</legend>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6 col-12" *ngIf="showBusinessOthers">
                    <div class="dtlSingle">
                      <label class="font-14">Category Of Business Others</label>
                      <legend class="medium font-16">{{ kycData?.businessOthers ?? "NA" }}</legend>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div class="dtlSingle">
                      <label class="font-14">Authorised Person Name</label>
                      <legend class="medium font-16">{{ kycData?.regCompAuthPerson ?? "NA" }}</legend>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div class="dtlSingle">
                      <label class="font-14">Designation</label>
                      <legend class="medium font-16">{{ kycData?.regCompDesignation ?? "NA" }}</legend>
                    </div>
                  </div>
                 
                </div>
                <div class="tableDocuments">
                  <table>
                    <thead>
                      <tr>
                        <th>Uploaded Documents</th>
                        <th>Attachments</th>
                      </tr>
                    </thead>
                    <tr *ngFor="let item of kycDetails">
                      <td>{{ item.title }}</td>
                      <td>
                        <ng-container *ngTemplateOutlet="getFile; context: { $implicit: item }"></ng-container>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>

            <div class="detailsItem">
              <h4 class="itemTitle flex alignCenter font-16" [ngClass]="activeIndex == 2 ? 'active' : ''" (click)="toggleAccordion(2)">
                <lucide-icon name="MapPin" class="user_icon"></lucide-icon>
                Registered Address
                <span class="accordianButton" [ngClass]="activeIndex == 2 ? 'active' : ''">
                  <lucide-icon name="chevron-down" [size]="16" class="lucid-icon-arrow"></lucide-icon>
                </span>
              </h4>
              <!-- <div class="col-sm-12" style="color: red;">Registered Address</div> -->
              <div class="accordion-content" *ngIf="activeIndex == 2">
                <div class="row">
                  <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div class="dtlSingle">
                      <label class="font-14">Company Name</label>
                      <legend class="medium font-14">{{ kycData?.regCompName ?? "NA" }}</legend>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div class="dtlSingle">
                      <label class="font-14">Address Line 1</label>
                      <legend class="medium font-16">{{ kycData?.regBuilding ?? "NA" }}</legend>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div class="dtlSingle">
                      <label class="font-14">Address Line 2</label>
                      <legend class="medium font-16">{{ kycData?.regCompStreet ?? "NA" }}</legend>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div class="dtlSingle">
                      <label class="font-14">Zipcode</label>
                      <legend class="medium font-16">{{ kycData?.regCompPincode ?? "NA" }}</legend>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div class="dtlSingle">
                      <label class="font-14">Country</label>
                      <legend class="medium font-16">{{ kycData?.regCompCountryName ?? "NA" }}</legend>
                    </div>
                  </div>

                  <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div class="dtlSingle">
                      <label class="font-14">Email</label>
                      <legend class="medium font-16">{{ kycData?.regCompEmail ?? "NA" }}</legend>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div class="dtlSingle">
                      <label class="font-14">Mobile No.</label>
                      <legend class="medium font-16">{{ kycData?.regCompMobile ?? "NA" }}</legend>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div class="dtlSingle">
                      <label class="font-14">Office Telephone No.</label>
                      <legend class="medium font-16">{{ kycData?.regCompTelephone ?? "NA" }}</legend>
                    </div>
                  </div>
                </div>
                <div class="tableDocuments">
                  <table>
                    <thead>
                      <tr>
                        <th>Uploaded Documents</th>
                        <th>Attachments</th>
                      </tr>
                    </thead>
                    <tr *ngFor="let item of registeredAddress">
                      <td>{{ item.title }}</td>
                      <td>
                        <ng-container *ngTemplateOutlet="getFile; context: { $implicit: item }"></ng-container>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>

            <div class="detailsItem">
              <h4 class="itemTitle flex alignCenter font-16" [ngClass]="activeIndex == 3 ? 'active' : ''" (click)="toggleAccordion(3)">
                <lucide-icon name="MapPin" class="user_icon"></lucide-icon>
                Correspondence Address
                <span class="accordianButton" [ngClass]="activeIndex == 3 ? 'active' : ''">
                  <lucide-icon name="chevron-down" [size]="16" class="lucid-icon-arrow"></lucide-icon>
                </span>
              </h4>
              <div class="accordion-content" *ngIf="activeIndex == 3">
                <div class="row">
                  <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div class="dtlSingle">
                      <label class="font-14">Company Name</label>
                      <legend class="medium font-16">{{ kycData?.corCompName ?? "NA" }}</legend>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div class="dtlSingle">
                      <label class="font-14">Address Line 1</label>
                      <legend class="medium font-16">{{ kycData?.corBuilding ?? "NA" }}</legend>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div class="dtlSingle">
                      <label class="font-14">Address Line 1</label>
                      <legend class="medium font-16">{{ kycData?.corCompStreet ?? "NA" }}</legend>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div class="dtlSingle">
                      <label class="font-14">Zipcode</label>
                      <legend class="medium font-16">{{ kycData?.corCompPincode ?? "NA" }}</legend>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div class="dtlSingle">
                      <label class="font-14">Country</label>
                      <legend class="medium font-16">{{ kycData?.corCompCountryName ?? "NA" }}</legend>
                    </div>
                  </div>
                  <!-- <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                  <div class="dtlSingle">
                    <label class="font-12">Authorised Person Name</label>
                    <legend class="medium">{{ kycData?.corCompAuthorizedPerson ?? "NA" }}</legend>
                  </div>
                </div>
                <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                  <div class="dtlSingle">
                    <label class="font-12">Designation</label>
                    <legend class="medium">{{ kycData?.corCompDesignation ?? "NA" }}</legend>
                  </div>
                </div> -->
                  <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div class="dtlSingle">
                      <label class="font-14">Email</label>
                      <legend class="medium font-16">{{ kycData?.corCompEmail ?? "NA" }}</legend>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div class="dtlSingle">
                      <label class="font-14">Mobile No.</label>
                      <legend class="medium font-16">{{ kycData?.corCompMobile ?? "NA" }}</legend>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div class="dtlSingle">
                      <label class="font-14">Office Telephone No.</label>
                      <legend class="medium font-16">{{ kycData?.corCompTelephone ?? "NA" }}</legend>
                    </div>
                  </div>
                </div>
                <div class="tableDocuments">
                  <table>
                    <thead>
                      <tr>
                        <th>Uploaded Documents</th>
                        <th>Attachments</th>
                      </tr>
                    </thead>
                    <tr *ngFor="let item of correspondenceAddress">
                      <td>{{ item.title }}</td>
                      <td>
                        <ng-container *ngTemplateOutlet="getFile; context: { $implicit: item }"></ng-container>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>

            <div class="detailsItem">
              <h4 class="itemTitle flex alignCenter font-16" [ngClass]="activeIndex == 4 ? 'active' : ''" (click)="toggleAccordion(4)">
                <lucide-icon name="Landmark" class="user_icon"></lucide-icon>
                Finance & Bank Details
                <span class="accordianButton" [ngClass]="activeIndex == 4 ? 'active' : ''">
                  <lucide-icon name="chevron-down" [size]="16" class="lucid-icon-arrow"></lucide-icon>
                </span>
              </h4>
              <div class="accordion-content" *ngIf="activeIndex == 4">
                <div class="row">
                  <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div class="dtlSingle">
                      <label class="font-14">Tax Number</label>
                      <legend class="medium font-16">{{ kycData?.taxNumber ?? "NA" }}</legend>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div class="dtlSingle">
                      <label class="font-14">Tax Number Type</label>
                      <legend class="medium font-16">{{ kycData?.taxType ?? "NA" }}</legend>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div class="dtlSingle">
                      <label class="font-14">Legal Status of the Company</label>
                      <legend class="medium font-16">{{ kycData?.legalStatusName ?? "NA" }}</legend>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div class="dtlSingle">
                      <label class="font-14">Bank Name</label>
                      <legend class="medium font-16">{{ kycData?.bankName ?? "NA" }}</legend>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div class="dtlSingle">
                      <label class="font-14">Account Number</label>
                      <legend class="medium font-16">{{ kycData?.accountNumber ?? "NA" }}</legend>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div class="dtlSingle">
                      <label class="font-14">IBAN Number</label>
                      <legend class="medium font-16">{{ kycData?.ibanNumber ?? "NA" }}</legend>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div class="dtlSingle">
                      <label class="font-14">SWIFT Code/ IFSC Code</label>
                      <legend class="medium font-16">{{ kycData?.swiftCode ?? "NA" }}</legend>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div class="dtlSingle">
                      <label class="font-14">Company Name as per Bank Records</label>
                      <legend class="medium font-16">{{ kycData?.bankAddress ?? "NA" }}</legend>
                    </div>
                  </div>
                  <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                    <div class="dtlSingle">
                      <label class="font-14">Cancelled Cheque</label>
                      <ng-container *ngTemplateOutlet="getFile; context: { $implicit: cancelCheque }"></ng-container>
                      <!-- <div class="file-upload-status flex alignCenter" *ngIf="kycData?.kycAttachment?.fileName; else naTemp">
                      <div class="col-lg-6 col-md-12 col-sm-12 flex alignCenter">
                        <span class="file-name" matTooltip="{{ kycData?.kycAttachment?.fileName }}" matTooltipPosition="left">
                          {{ kycData?.kycAttachment?.fileName }}
                        </span>
                      </div>
                      <div class="col-lg-6 col-md-12 col-sm-12 file-upload-size-info flex alignCenter">
                        <span class="file-size"> {{ kycData?.kycAttachment?.size }}</span>
                        <span (click)="downloadKycFile(kycData?.kycAttachment?.fileId, kycData?.kycAttachment?.fileName)">
                          <mat-icon>save_alt</mat-icon>
                        </span>
                      </div>
                    </div> -->
                      <ng-template #naTemp>
                        <legend class="medium">NA</legend>
                      </ng-template>
                    </div>
                  </div>
                </div>
                <div class="detailsItem">
                  <label class="font-14 annual-turnover">Annual Turnover (last 3 years, in USD)</label>
                  <div class="row">
                    <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                      <div class="dtlSingle">
                        <label class="font-14">Year</label>
                        <legend class="medium font-16">{{ kycData?.yearOne ?? "NA" }}</legend>
                      </div>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                      <div class="dtlSingle">
                        <label class="font-14">Amount</label>
                        <legend class="medium font-16">{{ kycData?.yearOneRevenue ?? "NA" }}</legend>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                      <div class="dtlSingle">
                        <label class="font-14">Year</label>
                        <legend class="medium font-16">{{ kycData?.yearTwo ?? "NA" }}</legend>
                      </div>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                      <div class="dtlSingle">
                        <label class="font-14">Amount</label>
                        <legend class="medium font-16">{{ kycData?.yearTwoRevenue ?? "NA" }}</legend>
                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                      <div class="dtlSingle">
                        <label class="font-14">Year</label>
                        <legend class="medium font-16">{{ kycData?.yearThree ?? "NA" }}</legend>
                      </div>
                    </div>
                    <div class="col-lg-3 col-md-4 col-sm-6 col-12">
                      <div class="dtlSingle">
                        <label class="font-14">Amount</label>
                        <legend class="medium font-16">{{ kycData?.yearThreeRevenue ?? "NA" }}</legend>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="tableDocuments">
                  <table>
                    <thead>
                      <tr>
                        <th>Uploaded Documents</th>
                        <th>Attachments</th>
                      </tr>
                    </thead>
                    <tr *ngFor="let item of financeDetails">
                      <td>{{ item.title }}</td>
                      <td>
                        <ng-container *ngTemplateOutlet="getFile; context: { $implicit: item }"></ng-container>
                      </td>
                    </tr>
                  </table>
                </div>
              </div>
            </div>
            <!-- </div> -->
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>
  </div>
</div>
<div class="overlayDrop" *ngIf="rightPanelActive" (click)="closeDisclosuer($event)"></div>
<div class="layout-rightpanel" [ngClass]="{ 'layout-rightpanel-active': rightPanelActive }">
  <app-nda-upload
    (updateNda)="onUpdateNda()"
    [customerInfo]="customerData"
    (childClick)="onChildClose()"
    [user]="user"
    *ngIf="rightPanelActive"
  ></app-nda-upload>
</div>
<ng-template #getFile let-item>
  <div *ngIf="isExistItem(item.key); else noFile">
    <div *ngFor="let fileItem of kycData?.kycFiles">
      <div class="fileView" *ngIf="fileItem.useFor === item.key">
        <span (click)="downloadKycFile(fileItem?.fileId, fileItem?.fileName)">
          {{ fileItem.fileName }}
        </span>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #noFile>
  <span>NA</span>
</ng-template>
